import { render, staticRenderFns } from "./single-switching-setting.vue?vue&type=template&id=07fb22fc"
import script from "./single-switching-setting.vue?vue&type=script&lang=js"
export * from "./single-switching-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports